module.exports = __webpack_public_path__ + "img/ouvidoria.7e3809e9.svg";